import { actionTypes } from '../actions/constants';

export default function headerReducer(
    state = {
        initialTrackingFired: false,
        isVipCuratedFolderTooltipVisible: false,
        isTradeRewardsNavigationTooltipVisible: false,
    },
    action
) {
    switch (action.type) {
        case actionTypes.SET_UPDATE_USER_STATE:
            return {
                ...state,
                updateUserState: action.updateUserState,
                initialTrackingFired: false,
            };
        case actionTypes.INITIAL_TRACKING_FIRED:
            return {
                ...state,
                initialTrackingFired: true,
            };
        case actionTypes.REGISTRATION_TRIGGER_TEST_FIRED:
            return {
                ...state,
                registrationTriggerTestFired: true,
            };
        case actionTypes.RESET_TRACKING_FIRED:
            return {
                ...state,
                initialTrackingFired: false,
            };
        case actionTypes.SET_USER_TYPE_TRADE:
            return {
                ...state,
                isUserTypeTrade: action.isUserTypeTrade,
            };
        case actionTypes.SET_USER_TYPE_VIP:
            return {
                ...state,
                isUserTypeVip: action.isUserTypeVip,
            };
        case actionTypes.SET_DEVICE_TYPE:
            return {
                ...state,
                deviceType: action.deviceType,
            };
        case actionTypes.TOGGLE_MOBILE_MENU:
            return {
                ...state,
                isMobileMenuOpen: action.isMobileMenuOpen,
            };
        case actionTypes.SET_IS_EMAIL_ONLY:
            return {
                ...state,
                isEmailOnly: action.isEmailOnly,
            };
        case actionTypes.TOGGLE_VIP_CURATED_FOLDER_TOOLTIP_STATE:
            return {
                ...state,
                isVipCuratedFolderTooltipVisible: !state.isVipCuratedFolderTooltipVisible,
            };
        case actionTypes.SHOW_TRADE_REWARDS_NAVIGATION_TOOLTIP:
            return {
                ...state,
                isTradeRewardsNavigationTooltipVisible: true,
            };
        case actionTypes.HIDE_TRADE_REWARDS_NAVIGATION_TOOLTIP:
            return {
                ...state,
                isTradeRewardsNavigationTooltipVisible: false,
            };
        default:
            return state;
    }
}
